import { render, staticRenderFns } from "./printSpaceGoodsLabelSet.vue?vue&type=template&id=5a438adf&scoped=true&"
import script from "./printSpaceGoodsLabelSet.vue?vue&type=script&lang=js&"
export * from "./printSpaceGoodsLabelSet.vue?vue&type=script&lang=js&"
import style0 from "./printSpaceGoodsLabelSet.vue?vue&type=style&index=0&id=5a438adf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a438adf",
  null
  
)

component.options.__file = "printSpaceGoodsLabelSet.vue"
export default component.exports